import { container } from "tsyringe";
export class UseCaseValidateEsim {
    constructor() {
        this.handle = async (request) => {
            try {
                return await this.esimProvider.validateEsim(request);
            }
            catch (error) {
                console.error("UseCaseValidateEsim error:", error);
                return {
                    available: false,
                    priceUsd: 0,
                    priceLocal: 0,
                    esimTotalUsd: 0,
                    esimTotalLocal: 0,
                    conversionRate: 0,
                    coverageDays: 0,
                    destination: request.destinationCountry,
                };
            }
        };
        this.esimProvider = container.resolve("iEsimProvider");
    }
}
